import CountryPageRenderer from '../components/CountryPageRenderer';
import elSalvadorData from '../data/country-pages/el-salvador';

export default function ElSalvadorCountryPage() {
  return <CountryPageRenderer data={elSalvadorData} />;
}
